import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 3h18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 7H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 11H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 19h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 15h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 3v14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "4", cy: "19", r: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Blinds";
const Blinds = memo(themed(Icon));
export {
  Blinds
};
//# sourceMappingURL=blinds.js.map
